import gtm from '@/utils/gtm';
import EFPicture from '@elem/compCommon/EFPicture';
import classNames from 'classnames';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import { useState } from 'react';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import './index.scss';

export interface EcoBlogItemProps extends ImgVideoProps, EcoTabItemProps {
    /**
     * 底部内容
     */
    bottomContent?: React.ReactNode;
}

type FTabTypes = {
    title?: string;
    className?: string;
    pc?: string;
    h5?: string;
    pad?: string;
    items: EcoBlogItemProps[];
    layout: 'LImageRText' | 'Image';
};

export default function FTab(props: FTabTypes) {
    const prefixCls = `f-eco-tab`;

    const { className, pc, h5, items, title, layout = 'Image' } = props;

    const classes = classNames(prefixCls, 'eco-content', {
        [`${className}`]: className,
    });

    const [swiperA, setSwiperA] = useState<any>(null); // 用于点击tab时执行轮播切换
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeItem, setActiveItem] = useState(items[activeIndex] || {});

    // 使用布尔数组记录每个标签的点击状态
    const [clickedTabs, setClickedTabs] = useState<boolean[]>(new Array(items.length).fill(false));

    // 切换
    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveIndex(index);
        setActiveItem(items[index] || {});
        swiperA.slideToLoop(index);

        // 如果该标签未被点击过
        if (!clickedTabs[index]) {
            // 更新点击状态
            const newClickedTabs = [...clickedTabs];
            newClickedTabs[index] = true;
            setClickedTabs(newClickedTabs);

            // 触发GTM事件
            gtm.push({ event: 'uaEvent', event_name: 'tab_click', button_name: item.tabLabel, list_name: title || 'none' });
        }
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);
        setActiveItem(items[index] || {});
        // swiperA.slideToLoop(index);
    };

    return (
        <div className={classes}>
            <Swiper
                className={`${prefixCls}-s1`}
                loop={true}
                autoplay
                modules={[Autoplay]}
                onSlideChange={handleSlideChange}
                onSwiper={(swiperIns: any) => setSwiperA(swiperIns)}
            >
                {items.map((item, index: number) => {
                    return (
                        <SwiperSlide key={index} className={`${prefixCls}-s1-item`}>
                            {layout === 'Image' && (
                                <div className={`${prefixCls}-img`}>
                                    <EFPicture src={item.pc} srcMobile={item.h5} srcPad={item.pad} />
                                </div>
                            )}
                            {layout === 'LImageRText' && (
                                <div className={`${prefixCls}__content`}>
                                    <div className={`${prefixCls}-l`}>
                                        <EFPicture src={item.pc} srcMobile={item.h5} srcPad={item.pad} />
                                    </div>
                                    <div className={`${prefixCls}-r`}>{item.desc}</div>
                                </div>
                            )}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            {/* <div className={`${prefixCls}-img`}>
                <EFPicture src={activeItem.pc} srcMobile={activeItem.h5} srcPad={activeItem.pad} />
            </div> */}
            <div className={`${prefixCls}-tab`}>
                <EcoTab activeIndex={activeIndex} onChange={toggleItemHandle} items={items} />
            </div>
            <div className={`${prefixCls}-c2`}>{activeItem.bottomContent}</div>
        </div>
    );
}
